import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useReducer } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Box, IconButton, Play, Hide, Image } from '@miro-site/core';
import VideoModal from './VideoModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Wrapper = styled(Box).attrs({
  $styles: {
    maxWidth: [null, null, 1200]
  },
  $mx: 'auto',
  $mb: [33, null],
  $px: [null, 40],
  $pb: [null, 40],
  $pt: [null, 32]
}).withConfig({
  displayName: "SliderWithTabs__Wrapper",
  componentId: "sc-15z943o-0"
})([""]);
var MainContainer = styled(Box).attrs({
  $styles: {
    flexDirection: ['column-reverse', null]
  },
  $pt: [24, 28]
}).withConfig({
  displayName: "SliderWithTabs__MainContainer",
  componentId: "sc-15z943o-1"
})(["display:flex;"]);
var Main = styled(Box).attrs({
  $styles: {
    display: ['flex', null],
    overflow: ['auto', null],
    flexBasis: [null, 820]
  },
  $pt: [24, null]
}).withConfig({
  displayName: "SliderWithTabs__Main",
  componentId: "sc-15z943o-2"
})(["flex-grow:0;flex-shrink:0;"]);
var MainImageWrapper = styled(Box).attrs({
  $styles: {
    borderRadius: [8, 16],
    width: [498, null]
  },
  $ml: [20, null],
  $pb: [340, 560]
}).withConfig({
  displayName: "SliderWithTabs__MainImageWrapper",
  componentId: "sc-15z943o-3"
})(["overflow:hidden;position:relative;background-color:#f5f5f5;"]);
var MainImage = styled(Image).withConfig({
  displayName: "SliderWithTabs__MainImage",
  componentId: "sc-15z943o-4"
})(["position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;z-index:1;", " ", ";"], function (_ref) {
  var $active = _ref.$active;
  return $active ? "\n    transition: all 500ms ease-in-out;\n    opacity: 1;\n    transform: translate(0, 0);\n  " : "\n    opacity: 0;\n    transform: translate(0, -4px);\n  ";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    width: [498, 820]
  });
});
var TabsContainer = styled(Box).attrs({
  $ml: [null, 26],
  $styles: {
    flex: [null, '0 1 auto']
  }
}).withConfig({
  displayName: "SliderWithTabs__TabsContainer",
  componentId: "sc-15z943o-5"
})([""]);
var Tabs = styled(Box).attrs({
  $mb: [null, 24],
  $pl: [10, null],
  $styles: {
    display: ['flex', null],
    whiteSpace: ['nowrap', null],
    width: ['100%', null],
    overflowX: ['auto', null]
  }
}).withConfig({
  displayName: "SliderWithTabs__Tabs",
  componentId: "sc-15z943o-6"
})([""]);
var TabDescription = styled(Box).attrs({
  $styles: {
    whiteSpace: ['normal', null],
    fontSize: [14],
    lineHeight: [20],
    marginTop: [null, 16],
    display: [null, 'none']
  }
}).withConfig({
  displayName: "SliderWithTabs__TabDescription",
  componentId: "sc-15z943o-7"
})([""]);
var TabTitle = styled(Box).attrs({
  $styles: {
    fontSize: [18],
    lineHeight: [22],
    borderRadius: [null, 48],
    marginBottom: [16, null]
  }
}).withConfig({
  displayName: "SliderWithTabs__TabTitle",
  componentId: "sc-15z943o-8"
})(["font-weight:500;display:flex;align-items:center;"]);
var Tab = styled(Box).attrs(function (_ref3) {
  var $active = _ref3.$active;
  return {
    $pt: [24],
    $pr: [24, $active ? 24 : 20],
    $pb: [24, $active ? 24 : 8],
    $pl: [24],
    $mx: [10, null],
    $mt: [null, $active ? 24 : null],
    $mb: [null, $active ? 8 : null],
    $styles: {
      minHeight: [166, null],
      width: [273, null],
      flexBasis: [273, null],
      boxSizing: ['border-box', null],
      borderRadius: [null, 8]
    }
  };
}).withConfig({
  displayName: "SliderWithTabs__Tab",
  componentId: "sc-15z943o-9"
})(["position:relative;overflow:hidden;background-color:", ";flex-grow:0;flex-shrink:0;&:first-child{margin-top:0;}", " ", ""], function (_ref4) {
  var $active = _ref4.$active,
      theme = _ref4.theme;
  return $active ? theme.colors.lightBlue : 'transparent';
}, function (_ref5) {
  var $active = _ref5.$active;
  return !$active && css(["&:hover{", "{color:", ";}}", "{cursor:pointer;}"], TabTitle, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.blueHover;
  }, TabTitle);
}, function (_ref7) {
  var $active = _ref7.$active;
  return $active && css(["", "{display:block;}", "{cursor:auto;color:", ";", ";}"], TabDescription, TabTitle, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.primaryIndigo;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.normalizeStyles({
      marginBottom: [null, 16]
    });
  });
});
var ProgressBarAnimation = keyframes(["0%{width:0;}100%{width:100%}"]);
var ProgressBar = styled(Box).withConfig({
  displayName: "SliderWithTabs__ProgressBar",
  componentId: "sc-15z943o-10"
})(["background:#050038;width:0;height:2px;position:absolute;left:0;bottom:0;border-radius:2px;animation:", " 6s linear 1;"], ProgressBarAnimation);
var TabsMobileSpacer = styled(Box).attrs({
  $styles: {
    flexShrink: [0, null],
    width: [20, null]
  }
}).withConfig({
  displayName: "SliderWithTabs__TabsMobileSpacer",
  componentId: "sc-15z943o-11"
})([""]);
var VideoBlock = styled(Box).attrs({
  $pl: [null, 24],
  $styles: {
    display: ['none', 'flex']
  }
}).withConfig({
  displayName: "SliderWithTabs__VideoBlock",
  componentId: "sc-15z943o-12"
})(["cursor:pointer;"]);
var PlayBtn = styled(IconButton).withConfig({
  displayName: "SliderWithTabs__PlayBtn",
  componentId: "sc-15z943o-13"
})(["display:flex;justify-content:center;align-items:center;cursor:pointer;background:", ";border-radius:50%;flex-shrink:0;border-style:solid;border-color:", ";", ";div{", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primaryBlue;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primaryWhite;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.normalizeStyles({
    marginRight: [7, 8],
    width: [22, 24],
    height: [22, 24],
    borderWidth: [2, null]
  });
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.normalizeStyles({
    width: [24],
    height: [24],
    transform: ["translate(".concat(theme.multipliers.small(7), ", ").concat(theme.multipliers.small(5), ")"), "translate(".concat(theme.multipliers.mediumDown(9), ", ").concat(theme.multipliers.mediumDown(6), ")"), "translate(".concat(theme.multipliers.mediumUp(9), ", ").concat(theme.multipliers.mediumUp(6), ")"), "translate(".concat(theme.multipliers.large(9), ", ").concat(theme.multipliers.large(6), ")")]
  });
});
var VideoBlockInfo = styled(Box).withConfig({
  displayName: "SliderWithTabs__VideoBlockInfo",
  componentId: "sc-15z943o-14"
})(["display:flex;align-items:center;"]);
var VideoBlockTitle = styled(Box).attrs(function (_ref14) {
  var theme = _ref14.theme;
  return {
    $styles: {
      cursor: [null, 'pointer'],
      color: [theme.colors.primaryWhite, theme.colors.primaryBlue],
      fontWeight: [null, '500'],
      fontSize: [18],
      lineHeight: [24]
    }
  };
}).withConfig({
  displayName: "SliderWithTabs__VideoBlockTitle",
  componentId: "sc-15z943o-15"
})([""]);
var VideoBlockMobile = styled(Box).withConfig({
  displayName: "SliderWithTabs__VideoBlockMobile",
  componentId: "sc-15z943o-16"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";margin:0 auto;", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.primaryBlue;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.normalizeStyles({
    width: [259],
    height: [46],
    borderRadius: [32],
    paddingBottom: [2]
  });
});

var SliderReducer = function SliderReducer(state, action) {
  switch (action.type) {
    case 'tab/clicked':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeTabIndex: action.tabIndex,
        autoPlay: false
      });

    case 'tab/timeout':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeTabIndex: state.tabs.length === state.activeTabIndex + 1 ? 0 : state.activeTabIndex + 1
      });

    case 'video/toggled':
      return _objectSpread(_objectSpread({}, state), {}, {
        openVideo: !state.openVideo
      });

    default:
      throw new Error('Unknown action');
  }
};

var SliderWithTabs = function SliderWithTabs(_ref17) {
  var _ref17$tabs = _ref17.tabs,
      tabs = _ref17$tabs === void 0 ? [] : _ref17$tabs,
      video = _ref17.video;

  var _useReducer = useReducer(SliderReducer, {
    tabs: tabs,
    activeTabIndex: 0,
    autoPlay: true,
    openVideo: false
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    if (!state.autoPlay) {
      return;
    }

    var timeout = setTimeout(function () {
      dispatch({
        type: 'tab/timeout'
      });
    }, 6000);
    return function () {
      clearTimeout(timeout);
    };
  }, [state]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(VideoModal, {
        show: state.openVideo,
        videoId: video === null || video === void 0 ? void 0 : video.id,
        onClose: function onClose() {
          dispatch({
            type: 'video/toggled'
          });
        }
      }), /*#__PURE__*/_jsxs(MainContainer, {
        children: [/*#__PURE__*/_jsx(Main, {
          children: /*#__PURE__*/_jsx(MainImageWrapper, {
            children: tabs.map(function (tab, key) {
              var active = state.activeTabIndex === key;
              return /*#__PURE__*/_jsx("div", {
                "data-testid": "".concat(active ? 'active' : 'inactive', "-tab-content"),
                children: /*#__PURE__*/_jsx(MainImage, {
                  src: tab === null || tab === void 0 ? void 0 : tab.image.src,
                  name: tab === null || tab === void 0 ? void 0 : tab.image.alt,
                  $active: active
                })
              }, key);
            })
          })
        }), /*#__PURE__*/_jsxs(TabsContainer, {
          children: [/*#__PURE__*/_jsxs(Tabs, {
            children: [tabs.map(function (tab, index) {
              var active = state.activeTabIndex === index;
              return /*#__PURE__*/_jsxs(Tab, {
                $active: active,
                onClick: function onClick() {
                  dispatch({
                    type: 'tab/clicked',
                    tabIndex: index
                  });
                },
                "data-testid": "".concat(active ? 'active' : 'inactive', "-tab"),
                "data-active-tab": active,
                children: [/*#__PURE__*/_jsx(TabTitle, {
                  children: tab === null || tab === void 0 ? void 0 : tab.title
                }), /*#__PURE__*/_jsx(TabDescription, {
                  children: tab === null || tab === void 0 ? void 0 : tab.description
                }), state.autoPlay && active ? /*#__PURE__*/_jsx(ProgressBar, {}) : null]
              }, index);
            }), /*#__PURE__*/_jsx(TabsMobileSpacer, {})]
          }), /*#__PURE__*/_jsx(Hide, {
            $on: ['mobile'],
            children: /*#__PURE__*/_jsxs(VideoBlock, {
              children: [/*#__PURE__*/_jsx(PlayBtn, {
                icon: /*#__PURE__*/_jsx(Play, {}),
                label: "Miro"
              }), /*#__PURE__*/_jsx(VideoBlockInfo, {
                children: /*#__PURE__*/_jsx(VideoBlockTitle, {
                  onClick: function onClick() {
                    dispatch({
                      type: 'video/toggled'
                    });
                  },
                  children: video === null || video === void 0 ? void 0 : video.description
                })
              })]
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(Hide, {
      $on: ['mediumDown', 'mediumUp', 'large'],
      children: /*#__PURE__*/_jsxs(VideoBlockMobile, {
        onClick: function onClick() {
          dispatch({
            type: 'video/toggled'
          });
        },
        children: [/*#__PURE__*/_jsx(PlayBtn, {
          icon: /*#__PURE__*/_jsx(Play, {}),
          label: "Miro"
        }), /*#__PURE__*/_jsx(VideoBlockInfo, {
          children: /*#__PURE__*/_jsx(VideoBlockTitle, {
            children: video === null || video === void 0 ? void 0 : video.description
          })
        })]
      })
    })]
  });
};

export default SliderWithTabs;